import React from 'react'

import { IconProps } from './types'

const Inbox = ({ size, ...props }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.25 20V33.75H33.75V20M6.25 20V6.25H33.75V20M6.25 20H12.5C12.5 25 16.25 27.5 20 27.5C23.75 27.5 27.5 25 27.5 20H33.75"
      stroke="currentColor"
      strokeWidth="2.5"
    />
  </svg>
)
Inbox.displayName = 'Inbox'
Inbox.defaultProps = {
  size: 24,
}
export default Inbox
